<template>
	<div class="main">
		<section class="section">
			
			<div class="container">
				<section class="main__grid test">
					<aside class="">
						<ul class="assessment">
							<template v-if="loadingQuiz">
								<div class="loader">
									<Loader />
								</div>
							</template>
							<template v-else-if="quizLoaded && quizzes.length">
								<TestItem 
									v-for="quiz in quizzes"
									:key="quiz.id"
									:quiz="quiz"
									:activeId="activeQuiz"
									@click.native="setActiveQuiz(quiz.id, quiz)"/>
							</template>
							<template v-else>
								<li class="assessment-item padded">
									No quiz to display yet
								</li>
							</template>
						</ul>
						<a @click="showVideo" href="#" class="btn btn__link">Watch Video</a>
						<div @click="closeVideo" ref="vidWrap" class="vid__wrapper">
							<div class="vid__lightbox">
								<div class="vid__lightbox-content">
									<button class="btn btn__close" @click="closeVideo">Close </button>
									<div class="vid__embed">
										<iframe ref="youtubeEmbed" id="youtube-embed" width="100%" height="400" src="https://www.youtube.com/embed/QCshuJ-Fmt0?showinfo=0&controls=0" frameborder="0" allowfullscreen></iframe>
									</div> 
								</div>
							</div>
						</div>
					</aside>
					<main class="center">
						<div class="test__main">
							<div class="test__meta">
								<span class="icon">
									<svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 0A5.52 5.52 0 0 0 0 5.5C0 8.53 2.48 11 5.5 11 8.53 11 11 8.53 11 5.5 11 2.48 8.53 0 5.5 0zm0 9.63A4.14 4.14 0 0 1 1.37 5.5 4.14 4.14 0 0 1 5.5 1.37 4.14 4.14 0 0 1 9.63 5.5 4.14 4.14 0 0 1 5.5 9.63zm.17-6.88h-.86v3.14L7.8 7.56l.46-.68-2.58-1.41V2.75z" fill="#333" fill-opacity=".9"/>
									</svg>
								</span>
								<span class="date">{{date}}</span>
								<span>{{ time }}</span>
							</div>
							<template v-if="testSubmitted || testResult">
								<div class="pre-test">
									<h4 class="bold">This Test has been taken.</h4>
								</div>
							</template>
							<template v-else>
								<template v-if="activeQuiz && testStarted">
									<h3 class="bold">{{activeQuizTitle}}</h3>
									Please select the option that best describes you.
									<ul class="test__body">
										<template v-if="loadingQuestions">
											<div class="loader">
												<Loader />
											</div>
										</template>
										<template v-else-if="questionsLoaded && questions.length">
											<Question 
												v-for="question in questions"
												:key="question.id"
												:question="question"/>
											<div class="py-30">
												<div class="hero__group">
												<router-link
													:to="{ name: 'test-score', params: {id: activeQuiz}}"
													class="btn__primary btn__primary--link"
													@click.native="submitQuiz"
													exact>Submit Test</router-link>
												</div>
											</div>
										</template>
										<template v-else>
											<li class="test__item">
												No questions available yet.
											</li>
										</template>
									</ul>
								</template>
								<template v-else>
									<div class="pre-test">
										<h3 v-if="!activeQuiz">Select a Test</h3>
										<div v-else-if="loadingPsychoScores" class="loading">
											<Loader />
										</div>
										<h4 v-else>Click on the start assessment button to get started.</h4>
									</div>
								</template>
							</template>
						</div>
					</main>
					<aside class="test__side">
						<h5 class="test__title bold">Countdown Timer</h5>
						<span class="time">
							{{ minutes }}:{{ seconds }}
						</span>
						<div class="py-30">
							<button
								class="btn__primary btn__primary--alt"
								@click="startAssessment"
								:disabled="!activeQuiz"
							>
								Start Assessment
							</button>
						</div>

						<div class="test__sub-section">
							<h6 class="title">Questions Answered</h6>
							<span>{{questionsAnswered}}/{{questions.length}}</span>
						</div>
					</aside>
				</section>
			</div>
		</section>        
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { setInterval, clearInterval } from 'timers';
import { 
	getQuizzes, 
	getQuestions, 
	submitTestQuiz
} from '../../utils/api/quiz';
import Loader from '../../components/Loader';
import TestItem from './TestItem';
import Question from './Question';
import { success, fail } from '../../utils/toast';
import eventHub from '../../utils/eventhub';

export default {
	name: 'Index',
	data() {
		return {
			loadingQuiz: false,
			quizLoaded: false,
			quizzes: [],
			questions: [],
			loadingQuestions: false,
			questionsLoaded: false,
			activeQuiz: null,
			activeQuizTitle: '',
			activeQuizDuration: 0,
			score: 0,
			questionsAnswered: 0,
			questionsLength: 0,
			timer: null,
			response: [],
			totalTime: 0,
			testStarted: false,
			testSubmitted: false,
			testResult: null,
			loadingPsychoScores: false,
			psychoScoresLoaded: false,
			duration: 0
		};
	},
	computed: {
		date() {
			return moment().format('dddd, MMMM Do YYYY');
		},
		time() {
			return moment().format('h:mm a');
		},
		...mapGetters({
			totalScore: 'getScore',
			answeredQuestions: 'answeredQuestions',
			userScore: 'userScore',
			userObject: 'userObject'
		}),
		minutes() {
			const minutes = Math.floor(this.totalTime / 60); 
			return minutes < 10 ? `0${minutes}` : minutes;
		},
		seconds() {
			const seconds = Math.floor(this.totalTime - (this.minutes * 60));
			return seconds < 10 ? `0${seconds}` : seconds;
		}
	},
	created() {
		this.fetchQuiz();
		this.resetQuiz();
		/**
		 * Check if a key of timer has previously been
		 */
		for (let i = 0; i < localStorage.length; i += 1) {
			const key = localStorage.key(i);
			if (key === 'timer') {
				const value = localStorage.getItem(key);
				this.totalTime = value;
			}
		}
		eventHub.$on('response', (payload) => {
			if (!this.response.length) {
				this.response.push(payload);
				return;
			}
			const item = this.response.find(res => res.question_id === payload.question_id);
			if (item) {
				this.response.find(res => res.question_id === payload.question_id).response = payload.response;
			} else this.response.push(payload);
		});
		window.onbeforeunload = function () {
			const isLeaving = window.confirm('You have an ongoing Test, Do you still want to leave?');
			if (isLeaving) {
				return true;
			}
			if (this.testStarted) {
				const key = 'timer';
				localStorage.setItem(key, this.totalTime);
			}
			return false;
		};
		if (this.$session.get('category') === 'employer') {
			this.$router.push('/jobs');
		}
		eventHub.$on('set-duration', (payload) => {
			this.duration = payload;
		});
	},
	mounted() {
		if (this.userObject.is_credential_uploaded !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly update your credentials to proceed, you are being redirected.',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
			}, 5000);
		} else if (this.userObject.is_psychometric_completed === 1) {
			fail({
				title: 'Notice!',
				text: 'You have already completed the psychometric test',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
			}, 50);
		}
		this.showVideo();
		this.totalTime = this.quizzes.duration || 0;
	},
	beforeRouteLeave(to, from, next) {
		if (this.testStarted) {
			const key = 'timer';
			localStorage.setItem(key, this.totalTime);
			next();
			return;
		}
		next();
	},
	watch: {
		totalScore(value) {
			this.score = value;
		},
		answeredQuestions(value) {
			this.questionsAnswered = value;
		}
	},
	methods: {
		showVideo() {
			const vid = this.$refs.youtubeEmbed.src;
			this.$refs.youtubeEmbed.src = `${vid}&autoplay=1`;
			this.$refs.vidWrap.style.display = 'block';
		},
		closeVideo() {
			const vid = this.$refs.youtubeEmbed.src;
			const resetVid = vid.replace('&autoplay=1', '');
			this.$refs.youtubeEmbed.src = resetVid;
			this.$refs.vidWrap.style.display = 'none';
		},
		...mapMutations([
			'resetQuiz',
			'updateUserObject'
		]),
		setActiveQuiz(id, quiz) {
			this.activeQuiz = id;
			this.activeQuizTitle = quiz.title;
			this.activeQuizDuration = quiz.duration;
			// check if test has been taken before fetching questions
			this.getPsychoScores();
			this.resetTimer();
		},
		getPsychoScores() {
			const userData = this.$session.get('userData');
			this.loadingPsychoScores = true;

			this.testResult = userData.is_psychometric_completed;
			if (!this.testResult) {
				this.psychoScoresLoaded = true;
				this.fetchQuestions(this.activeQuiz);
			}
			this.psychoScoresLoaded = false;
			return false;
		},
		fetchQuiz() {
			this.loadingQuiz = true;
			getQuizzes()
				.then((response) => {
					if (response.status === 200) {
						this.quizLoaded = true;
						this.quizzes = response.data.data;
					}
				})
				.catch((error) => {
					this.loading = false;
					this.quizLoaded = false;
					return error;
				})
				.finally(() => {
					this.loadingQuiz = false;
				});
			return true;
		},
		fetchQuestions(id) {
			this.loadingQuestions = true;
			getQuestions(id)
				.then((response) => {
					if (response.status === 200) {
						this.questionsLoaded = true;
						this.loadingPsychoScores = false;
						this.questions = response.data.data;
						this.questionsLength = this.questions.length;
						this.loadingQuestions = false;
					}
				})
				.catch((error) => {
					this.loading = false;
					this.questionsLoaded = false;
					return error;
				});
			return true;
		},
		submitQuiz() {
			const data = {
				quiz_id: this.activeQuiz,
				user_id: this.$session.get('id'),
				quiz_response: this.response
			};
			this.testStarted = false;
			localStorage.removeItem('timer');
			submitTestQuiz(data)
				.then((response) => {
					if (response.status === 201) {
						this.updateUserObject({ is_psychometric_completed: 1 });
						success({
							title: 'Success! You have successfully completed the quiz!.'
						});
						this.testSubmitted = true;
						const userData = this.$session.get('userData');
						userData.is_pyschometric_completed = true;
						this.$session.set('userData', userData);
						return true;
					}
					return false;
				})
				.catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					return false;
				});
			return true;
		},
		startTimer() {
			this.timer = setInterval(() => this.countdown(), 1000);
		},
		resetTimer() {
			this.totalTime = this.activeQuizDuration;
			clearInterval(this.timer);
			this.timer = null;
		},
		stopTimer() {
			clearInterval(this.timer);
			this.timer = null;
		},
		countdown() {
			if (this.totalTime >= 1) {
				this.totalTime -= 1;
			} else {
				this.totalTime = 0;
				this.submitQuiz();
				this.resetTimer();
			}
		},
		startAssessment() {
			this.testStarted = true;
			this.startTimer();
		}
	},
	components: {
		TestItem,
		Loader,
		Question
	}
};
</script>

<style lang="scss" scoped>
.vid {
	&__wrapper {
		background-color: rgba(0, 0, 0, 0.8);  
		overflow: scroll;
		position: fixed;
		display: none;
		z-index: 1;
		bottom: 0;
		right: 0;
		left: 0;
		top: 0;
	}
	&__embed {
		position: relative;
		overflow: hidden;
		height: 0;
		padding-top: 30px;
		padding-bottom: 56.25%;
	}
	&__lightbox {
		position: relative;
		display: block;
		max-width: 960px;
		height: auto;
		z-index: 20;
		margin: 50px auto;
		padding: 0 5%;
	}
}
.assessment__item {
	border-bottom: 1px solid $grey-lighter;
	&.active {
		border-color: transparent;
	}
}
.option {
	max-width: max-content;
}
.loader {
	width: 100%;
	min-height: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.text {
	display: inline;
}
.btn__primary {
	&:disabled {
		cursor: not-allowed;
		background: lightgrey;
	}
}
.pre-test {
	min-height: 50vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
}
.padded {
	padding: 30px 40px;
}
.btn {
	&__link {
		max-width: 70%;
		margin: 30px auto;
		justify-content: center;
	}
	&__close {
		position: absolute;
		background: transparent;
		font-size: 12px;
		display: block;
		border: none;
		color: $white;
		top: -20px;
		right: 7%;
	}
}
.video__embed iframe,
.video__embed object,
.video__embed embed {
	position: absolute;
    height: 100%;  
    width: 100%;  
    left: 0;  
    top: 0;
}


</style>

